// extracted by mini-css-extract-plugin
module.exports = {"visually-hidden":"EmbeddedAsset_visually-hidden__kFs8i","resetButton":"EmbeddedAsset_resetButton__hkilI","caption":"EmbeddedAsset_caption__tK5C_"};